import React, { useEffect, useState } from 'react'
import './index.scss'
import AnimatedLetters from '../AnimatedLetters'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {  faCss3, faBootstrap, faHtml5, faJsSquare, faReact, faSass } from '@fortawesome/free-brands-svg-icons'
import Loader from 'react-loaders'

function About() {
    
    
    const [letterClass, setLettersClass] = useState("text-animate")



  useEffect(()=>{
    return()=> setTimeout(()=>{
      setLettersClass("text-animate-hover")
    },4000)
  },[])

  return (
    <>


    <div className="container-short">

    
    <div className='container '>
      <div className="about-page">


        <div className="text-zone">
            <h1>
                <AnimatedLetters letterClass={letterClass} strArray={['A','b','o','u','t' , ' ' , 'm','e' ]}
                idx={15}
                />
            </h1>
            <p>I've mastered the essentials, including writing clean, semantic HTML and creating elegant, responsive layouts with CSS. JavaScript is my playground for enhancing interactivity. In addition.</p>
            <p> I've delved into advanced technologies, harnessing the power of React for building dynamic, data-driven web applications. My toolkit also includes SASS, a CSS preprocessor that streamlines styling and boosts maintainability</p>

            <p>I can also convert Figma, PSD, and XD designs into clean, functional HTML, leveraging my expertise in these design-to-code transformations.Whether it's Figma, PSD, or XD, I have the proficiency to convert these design files into pixel-perfect HTML, enabling your projects to come to life on the web</p>
        </div>


        <div className="stage-cube-cont">
            <div className="cubespinner">
         
            <div className="face1">
              <FontAwesomeIcon icon={faBootstrap} color="#DD0031" />
            </div>
            <div className="face2">
              <FontAwesomeIcon icon={faHtml5} color="#F06529" />
            </div>
            <div className="face3">
              <FontAwesomeIcon icon={faCss3} color="#28A4D9" />
            </div>
            <div className="face4">
              <FontAwesomeIcon icon={faReact} color="#5ED4F4" />
            </div>
            <div className="face5">
              <FontAwesomeIcon icon={faJsSquare} color="#EFD81D" />
            </div>
            <div className="face6">
              <FontAwesomeIcon icon={faSass} color="#EC4D28" />
            </div>
            </div>
        </div>
      

    </div>
    </div>
    </div>
    <Loader type="pacman" />
    </>
  )
}

export default About
